module.exports = __webpack_public_path__ + "/login_ui/img/george-tick-4a3b0f0cec7837697d6de6ca45b1b642.svg";